(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name usuaris.llista.controller:LlistaCtrl
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.usuaris.main.llista')
    .controller('UsuarisMainLlistaCtrl', UsuarisMainLlistaCtrl);

  function UsuarisMainLlistaCtrl($rootScope,$scope, HelperFactory, Notification, UsuariFactory, $window, $state, $stateParams,LogoutFactory,llistaentitats,$translate) {
    var vm = this;
    vm.ctrlName = 'UsuarisMainLlistaCtrl';

    vm.calculateListFields = calculateListFields;
    vm.load = load;
    vm.view = view;
    vm.edit=edit;
    vm.deleteUsuari=deleteElem;

    vm.llista = [];
    vm.page = 1;
    vm.perPage = 25;
    vm.pages = 0;
    vm.canLoad = true;
    vm.auxentitatsel=[];
    vm.indexeliminat=-1;

    vm.cercaObj = {
      page : vm.page,
      perPage: vm.perPage,
      pages: vm.pages,
      entitatsel:[],
      username: '',
      identitat:''
    };

   if (!angular.isUndefined(llistaentitats)){
      vm.listallentitat=llistaentitats.data.list;
    }


 function onChangeFunction(){
      vm.cercaObj.identitat=null;
      if (vm.cercaObj.entitatsel!=null){
        if (vm.cercaObj.entitatsel.length>0){
          vm.cercaObj.identitat=vm.cercaObj.entitatsel[0].id;
          vm.searchText = null;
        }
      }
    }

    if ($rootScope.issuperadmin){
      vm.formulari = {
        nom: 'cercador',
        func: function(){
          return cercar();
        },
        camps: [
           {
              type: 'text',
              name: 'username',
              label: 'DEFAULT_USERNAME',
              columns: 4,
              required: false
            },
            {
              type: 'text',
              name: 'entitat',
              label: 'DEFAULT_CODI_client',
              columns: 4,
              required: false
            },
            {
                type: 'chips',
                name: 'entitatsel',
                list:vm.listallentitat,
                master: true,
                fieldProperty: 'nom',
                textPlaceholder: $translate.instant('USUARIENTITAT_CERCA'),
                columns: 4,
                label:"CERCA_ENTITATS",
                onChange :  onChangeFunction,
                mdMaxChips:2
            }            
        ]
      }
    }
    else
    {
       vm.formulari = {
        nom: 'cercador',
        func: function(){
          return cercar();
        },
        camps: [
            {
              type: 'text',
              name: 'username',
              label: 'DEFAULT_USERNAME',
              columns: 6,
              required: false
            }
        ]
      }
    }
    vm.formatter = formatter;
    function formatter(object, field) {
      var css = '';
      if (field === 'username' && (object.deleted || object.fictici) ) {
        css = 'color:#dd2c00;';
      }else if (field === 'username' && !object.confirmat){
        css = 'color:#ffa500;';
      }
      return css;
    };


    function loadUsuaris() {
      if (!angular.isUndefined($rootScope.permisos.LOGIN) && $rootScope.permisos.LOGIN.read){
        vm.auxentitatsel=vm.cercaObj.entitatsel;
        vm.cercaObj.entitatsel=[];
        var promise = UsuariFactory.getAll(vm.cercaObj).then(function(response){
          $scope.$evalAsync(function(){
            vm.cercaObj.pages = response.data.pages;
            vm.cercaObj.page = response.data.page + 1;
            angular.forEach(response.data.list, function(entrada) {
               vm.llista.push(entrada);
            });
          });
        }).catch(function(error){
          Notification.processError(error);
        });
        vm.cercaObj.entitatsel=vm.auxentitatsel;
        return promise;
      }
      else{
        return undefined;
      }
    }

    function cercar(){
      vm.cercaObj.page = 1;
      vm.cercaObj.pages = undefined;
      vm.llista = [];
      return loadUsuaris();
    }

    function load(){
      if (!angular.isUndefined(vm.cercaObj.pages) && (vm.cercaObj.page < (vm.cercaObj.pages + 1)) ) {
        vm.canLoad = false;
        loadUsuaris().then(function(){
          $scope.$evalAsync(function(){
            vm.canLoad = true;
          });
        });
      }
    }

    function calculateListFields(reductedList){
      if (reductedList){
        vm.fields = [
          {
            header: 'DEFAULT_USERNAME',
            type: 'text',
            name: 'username'
          },
          {
            header: 'DEFAULT_ACCIONS',
            type: 'actions',
            name: 'id'
          }
        ];
      } else{
        vm.fields = [
          {
            header: 'DEFAULT_USERNAME',
            type: 'text',
            name: 'username'
          },
          {
            header: 'DEFAULT_ENTITAT',
            type: 'text',
            name: 'nomEntitat'
          },
          {
            header: 'DEFAULT_PRODUCTES',
            type: 'text',
            name: 'rols'
          },
          {
            header: 'DEFAULT_ACCIONS',
            type: 'actions',
            name: 'id'
          }
        ];

      }
    }

    function deleteElem(id) {
      UsuariFactory.delete(id).then(function(response){
        $scope.$evalAsync(function(){
          vm.indexeliminat=-1;
          vm.llista.forEach(function(elem, index) {
            if (elem.id === id){
              if (!$rootScope.issuperadmin){
                vm.llista.splice(index,1);
                vm.indexeliminat=index;
              }
              else{
                vm.llista[index].nomEntitat="";
                vm.llista[index].rols="";
              }
            }
          });

            if ($rootScope.issuperadmin){
              HelperFactory.setParams($stateParams, {'idUsuari': id});
              $state.go('usuaris.main.submain.dades', $stateParams, {'reload': 'usuaris.main.submain'});
            }
            else
            {
              if (vm.llista.length==0 )
              {
                HelperFactory.setParams($stateParams, {'idUsuari': null});
                $state.go('usuaris.main', $stateParams, {'reload': 'usuaris.main.submain'});
              }
              else
              {
                if (vm.llista.length==1)
                {
                  view(vm.llista[0]);
                }
                else{
                  if (vm.indexeliminat<vm.llista.length)
                  {
                    view(vm.llista[vm.indexeliminat]);
                  }
                  else
                  {
                    view(vm.llista[vm.indexeliminat-1]);
                  }
                }
              }
            }


        });
      }).catch(function(error){
        console.log(error);
        Notification.processError(error);
      });
    }



    function edit(id) {
      $window.scrollTo(0,0);
      HelperFactory.setParams($stateParams, {'isNew': false, 'idUsuari': id});
      $state.go('usuaris.main.submain.edit', $stateParams, {'reload': 'usuaris.main.submain'});
    }

    function view(obj) {
      $window.scrollTo(0,0);
      HelperFactory.setParams($stateParams, {'idUsuari': obj.id});
      $state.go('usuaris.main.submain.dades', $stateParams, {'reload': 'usuaris.main.submain'});
    }

    $scope.$on('addItemToTree', function(event, data) {
      HelperFactory.setParams($stateParams, {'isNew': true, 'idUsuari': undefined});
      $state.go('usuaris.main.submain.edit', $stateParams);
    });

    cercar();

    /*--------------------------------EVENTS ------------------------------*/

    $scope.$on('changeSides', function(event, data) {
      vm.calculateListFields(!data.left.collapsed && !data.links.collapsed);
    });

    $scope.$on('usuaris.main.delete', function(event, data) {
      deleteElem(data.id);
    });

     $scope.$on('usuaris.main.edit', function(event, data) {
      edit(data.id);
    });


    $scope.$on('usuaris.main.llista.update', function(event, data) {
      vm.llista.forEach(function(obj, index){
        if (obj.id === data.id) {
          var rols="";
          data.rols.forEach(function(obj, index){
            if (rols==""){
              rols =  obj.nom ;
            }
            else
            {
              rols = rols + ", " + obj.nom ;
            }
          });
          var entitats="";
          data.entitats.forEach(function(obj, index){
            if (entitats==""){
              entitats =  obj.nom ;
            }
            else
            {
              entitats = entitats + ", " + obj.nom ;
            }
          });

          obj.username = data.username;
          obj.rols=rols;
          obj.entitats=entitats;

          if (obj.username.indexOf(vm.cercaObj.username) == -1) {
            vm.llista.splice(index, 1);
          }
          Notification.success('GENERIC_SUCCESS');

          return;
        }
      });
    });

    $scope.$on('usuaris.main.llista.add', function(event, data) {
      $stateParams.idUsuari = data.id;
      if (data.username.indexOf(vm.cercaObj.username) != -1) {
          var rols="";
          data.rols.forEach(function(obj, index){
            if (rols==""){
              rols =  obj.nom ;
            }
            else
            {
              rols = rols + ", " + obj.nom ;
            }
          });
          var entitats="";
          data.entitats.forEach(function(obj, index){
            if (entitats==""){
              entitats =  obj.nom ;
            }
            else
            {
              entitats = entitats + ", " + obj.nom ;
            }
          });

          var obj={
            email:data.email,
            id:data.id,
            nomEntitat:entitats,
            rols:rols,
            username:data.username,
            fictici:data.fictici
          };
          vm.llista.push(obj);
      }
      HelperFactory.setParams($stateParams, {'idUsuari': $stateParams.idUsuari});
      $state.go('usuaris.main.submain.dades', $stateParams, {'reload': 'usuaris.main.submain'});

      Notification.success('GENERIC_SUCCESS');
    });

    if (angular.isUndefined($stateParams.idUsuari)){
      $rootScope.$broadcast('usuaris.main.showOptionSubmenu', {'show': false});
    }


  }
}());
